import { createStore, applyMiddleware, Store, Dispatch, Middleware } from "redux";
import createSagaMiddleware, { SagaMiddleware } from "redux-saga";
import { createLogger } from "redux-logger";

import rootReducer from "./root-reducer";
import rootSaga from "./root-saga";
import { IApplicationState } from "./application-state";
import { createPersistReducer, createPersistStore } from "./persist";
import { env } from "app/config";

// create the saga middleware
const sagaMiddleware: SagaMiddleware<{}> = createSagaMiddleware();
const middleWare: any[] = [sagaMiddleware];

//  create the persist reducer
const persistReducer = createPersistReducer(rootReducer);

// logger middleware
if (env.REACT_APP_ENV !== "production" && false) {
    const logger: Middleware = createLogger();
    middleWare.push(logger);
}

// mount it on the Store
const store: Store<IApplicationState> & {
    dispatch: Dispatch<any>;
} = createStore(persistReducer, applyMiddleware(...middleWare));

const persistor: any = createPersistStore(store);

// then run the saga
sagaMiddleware.run(rootSaga);

export { store, persistor };
